import { schema } from "normalizr";
import { BoardPermission } from "./permission";

export const BoardPermissions = new schema.Array(BoardPermission);
